/* eslint-disable react/require-default-props */
import React from 'react';
import { Label } from '../../../atoms/Label';
import { Checkbox } from '../Checkbox';
import './CheckboxListStyles.scss';
/**
 * CheckboxList Component
 * Displays a list of checkboxes for multiple selection
 * @version 1.1.1
 * @since 2026-01-27
 * @updated 2026-03-09 - Made label optional, added per-option disabled, added global disabled prop
 */
export function CheckboxList({ options, onChange, label, value, required = false, disabled = false, error = undefined }) {
    const onCheck = (valueChecked) => {
        onChange(valueChecked);
    };
    const onElementClick = (e, valueChecked) => {
        e.preventDefault();
        e.stopPropagation();
        onCheck(valueChecked);
    };
    return (React.createElement("div", { className: `qmb-ui-checkbox-list ${error ? 'qmb-ui-checkbox-list--has-error' : ''}` },
        label && (React.createElement(Label, { className: `qmb-ui-checkbox-list__label ${required ? 'qmb-ui-checkbox-list__label--required' : ''}` }, label)),
        React.createElement("div", { className: "qmb-ui-checkbox-list__options" }, options.map((option) => (React.createElement("div", { key: option.value, className: "qmb-ui-checkbox-list__option", onClick: (e) => {
                if (e.target.type !== 'checkbox') {
                    onElementClick(e, option.value);
                }
            }, role: "presentation" },
            React.createElement(Checkbox, { id: option.value.toString(), checked: value.includes(option.value), onChange: () => onCheck(option.value), onClick: (e) => e.stopPropagation(), label: option.title, description: option.description, disabled: disabled || option.disabled }))))),
        error && React.createElement("span", { className: "qmb-ui-checkbox-list__error-message" }, error)));
}
